module.exports = "<div class=\"flex-card\">\n  <div class=\"image-div skeleton-parent content-size\">\n    <div class=\"skeleton round-image\"></div>\n  </div>\n  <div class=\"skeleton-box\">\n    <div class=\"footer\">\n      <div class=\"row col-xs-4 skeleton-s\">\n        <div class=\"skeleton\"></div>\n      </div>\n      <div class=\"row col-xs-11 skeleton-xl\">\n        <div class=\"skeleton\"></div>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/content-tile-loading/content-tile-loading.component.html
// module id = 939
// module chunks = 0